import React, { useState, useEffect } from 'react';
import '../../styles/AddGradeModal.css';
import { toast } from 'react-toastify';
import API_BASE_URL from '../../config/apiConfig.js';
import fetchApi from '../../utils/api.js';
import Swal from 'sweetalert2';

function EditGradeModal({ isOpen, onClose, grade, isPage }) {
    const [gradeName, setGradeName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [companies, setCompanies] = useState([]);
    const [userRole, setUserRole] = useState('');

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        if (user) {
            setUserRole(user.role);
            if (user.role === 'SUPER_ADMIN') {
                fetchCompanies();
            }
        }
    }, [isOpen]);

    const fetchCompanies = async () => {
        try {
            const data = await fetchApi('/company');
            setCompanies(data.companies || data);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    useEffect(() => {
        if (grade) {
            setGradeName(grade.gradeName || grade.grade_name || '');
            const cid = grade.companyId?.id || grade.company_id || grade.companyId;
            setCompanyId(cid ? cid : 'all');
        }
    }, [grade]);

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        const conf = await Swal.fire({
            title: 'Save Data?',
            text: 'Are you sure you want to save this data?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#00334e',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'No, Keep Editing'
        });
        if (!conf.isConfirmed) return;

        const trimmedName = gradeName.trim();
        if (!trimmedName) {
            toast.error("Grade name cannot be empty");
            return;
        }

        try {
            const payload = { gradeName: trimmedName };
            if (userRole === 'SUPER_ADMIN') {
                payload.companyId = companyId;
            }

            const token = sessionStorage.getItem('token');
            const response = await fetch(`${API_BASE_URL}/grade/${grade._id || grade.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (response.ok) {
                toast.success("Grade updated successfully!");
                onClose();
            } else {
                toast.error(data.message || "Failed to update grade");
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Server error");
        }
    };

    if (!isOpen && !isPage) return null;
    if (isPage && !grade) return null;

    const formContent = (
        <div className={isPage ? "page-card" : "add-grade-modal"} onClick={(e) => !isPage && e.stopPropagation()} style={isPage ? { maxWidth: '100%', margin: '0' } : {}}>
            {!isPage && (
                <>
                    <button className="add-grade-close-icon" onClick={onClose}>✕</button>
                    <h2 className="add-grade-title">Update Grade</h2>
                </>
            )}
            {isPage && <div className="page-card__title">Update Grade</div>}

            <div className={isPage ? "page-card__body" : ""}>
                <form className="add-grade-form" onSubmit={handleSubmit} style={isPage ? { padding: '0' } : {}}>
                    {userRole === 'SUPER_ADMIN' && (
                        <div className="add-grade-field">
                            <label className="add-grade-label">Company <span style={{ color: 'red' }}>*</span></label>
                            <select
                                className="add-grade-input"
                                value={companyId}
                                onChange={(e) => setCompanyId(e.target.value)}
                                required
                            >
                                <option value="">Select Company</option>
                                <option value="all">All</option>
                                {companies.map((c) => (
                                    <option key={c._id || c.id} value={c._id || c.id}>
                                        {c.companyName || c.name || c.company_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="add-grade-field">
                        <label className="add-grade-label">Grade Name</label>
                        <input
                            className="add-grade-input"
                            placeholder="Enter grade name"
                            value={gradeName}
                            onChange={(e) => setGradeName(e.target.value)}
                        />
                    </div>

                    <div className="add-grade-actions">
                        <button type="button" className="add-grade-btn-cancel" onClick={onClose}>Cancel</button>
                        <button type="submit" className="add-grade-btn-submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );

    if (isPage) return formContent;

    return (
        <div className="add-grade-modal-overlay" onClick={onClose}>
            {formContent}
        </div>
    );
}

export default EditGradeModal;
